import React from 'react';
import { Box, Stack, Typography, MobileStepper } from '@mui/material'

const Card = (props) => {
  const slide = props.slide;
  return (
    <Box>
      <Stack alignItems="center" spacing={1}>
        <Box sx={{ width: { xs: '70%', md: '250px' } }}>
          <img src={slide.image} width="100%" />
        </Box>
        <MobileStepper
          variant="dots"
          steps={props.slideCount}
          position="static"
          activeStep={slide.no}
          sx={{ maxWidth: 400, flexGrow: 1 }}
          nextButton={
            null
          }
          backButton={
            null
          }
        />
        <Typography
          variant='h6'
          textAlign="center"
          fontSize={{xs: '0.8rem', md: '1.2rem'}}
        >
          {slide.title}: {slide.description}
        </Typography>
      </Stack>
    </Box>
  )
}

export default Card